import React from "react";
import layout from "../../layout/layout";

const AccountVerified = () => (
  <div>A verificação da sua conta é bem sucedida.</div>
);

export default layout(AccountVerified);
